// src/hooks/useProductDeliverySettings.js
// Shared hook — loads the productDelivery config (base location + tiers)
// from salons/{salonId} once per component mount.

import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';

export function useProductDeliverySettings(salonId) {
  const [baseLocation, setBaseLocation] = useState(null);
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!salonId) { setLoading(false); return; }
    let cancelled = false;

    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'salons', salonId));
        if (!cancelled && snap.exists()) {
          const pd = snap.data().productDelivery;
          setBaseLocation(pd?.baseLocation || null);
          setTiers(pd?.tiers || []);
        }
      } catch (err) {
        console.error('[useProductDeliverySettings] Error:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [salonId]);

  return { baseLocation, tiers, loading };
}
